import React from 'react';
import { get } from 'lodash';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { supportedChannels } from 'helpers/channels';
import ButtonStandardCompact from 'components/atoms/buttons/compact/Primary';
import FormSubHeading from 'components/atoms/form/FormSubHeading';
import LayerAliasesSubHeading from 'components/molecules/LayerAliasesSubHeading';
import ViewChannelConfiguration from 'components/molecules/ViewChannelConfiguration';
import DeleteIconButton from 'components/molecules/buttons/DeleteBrandButton';
import BrandSubheaderFieldName from 'components/atoms/form/BrandSubheaderFieldName';

const ViewBrand = (props) => {
    const brandId = get(props, 'brand.id', null);
    const brandAliases = get(props, 'brand.BrandAliases', []);
    const enrollmentSite = get(props, 'brand.enrollmentSite', false);
    const channels = props.brand ? supportedChannels : [];
    const channelConfig = get(props, 'brand.meta.channelConfig', {});

    return (
        <Row>
            <Col md={6}>
                {/* <!-- Left column -->     */}
                <LayerAliasesSubHeading />

                <Row>
                    <Col xs={4}><BrandSubheaderFieldName>Alias</BrandSubheaderFieldName></Col>
                    <Col xs={8}><BrandSubheaderFieldName>Layer Type</BrandSubheaderFieldName></Col>
                    {brandAliases.length === 0 &&
                        <Col xs={12}>No Brand Aliases</Col>
                    }
                </Row>

                {brandAliases.map((alias, index) => (
                    <Row key={index}>
                        <Col xs={4}>{alias.name}</Col>
                        <Col xs={8}>Layer {alias.layer}</Col>
                    </Row>
                ))}

                <ViewChannelConfiguration
                    channels={channels}
                    channelConfig={channelConfig}
                />

                <FormSubHeading>Marketing Enrollment Site</FormSubHeading>

                {enrollmentSite ?
                    <a href={enrollmentSite} target="_blank">{enrollmentSite}</a>
                    :
                    <span>No Marketing Enrollment Site</span>
                }

                <br />

                <Row>
                    <Col xs={6}>
                        <ButtonStandardCompact
                            margin="40px 0px 0px 0px"
                            type="submit"
                            onClick={() => props.push(`/admin/brands/${brandId}/edit`)}>
                            Edit
                        </ButtonStandardCompact>
                    </Col>
                    <Col xs={6}>
                        <DeleteIconButton
                            margin="40px 0px 0px 0px"
                            icon="trash"
                            iconColor="#F00"
                            onClick={() => props.deleteBrand(props.brand)}>
                            Delete
                        </DeleteIconButton>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

ViewBrand.propTypes = {
    brand: PropTypes.shape({
        enrollmentSite: PropTypes.string,
        BrandAliases: PropTypes.array,
        meta: PropTypes.shape({
            channelConfig: PropTypes.object
        })
    }),
    push: PropTypes.func,
    deleteBrand: PropTypes.func,
};

export default ViewBrand;



// WEBPACK FOOTER //
// ./src/components/organisms/brand/ViewBrand.js